import { v4 as uuid } from 'uuid'
import { AiUploadedImage } from './AiUploadImageSection'
import { AiUploadedDocument } from './AiUploadDocumentSection'
import { UploadedAttachmentState } from './aiDataExtractionRequest'

export const normalizeMultimediaAttachmentTitle = (title: string | undefined, fallbackTitle: string) => {
  if (!title) {
    return fallbackTitle
  }

  const normalizedTitle = title.trim().toLowerCase()
  return normalizedTitle === 'undefined' || normalizedTitle === 'null' ? fallbackTitle : title
}

export const revokeDocumentPreviewUrl = (document: AiUploadedDocument | null) => {
  if (document?.previewUrl) {
    URL.revokeObjectURL(document.previewUrl)
  }
}

export const asAttachmentUploadState = (
  status: UploadedAttachmentState['status'],
  attachment?: UploadedAttachmentState['attachment']
): UploadedAttachmentState => ({
  status,
  attachment,
})

/** From a file input FileList, keep only entries whose MIME type is an image (used for the photo batch). */
export const getSelectedImagesFromFileList = (files: FileList) =>
  Array.from(files).filter((file) => file.type.startsWith('image/'))

export const hasAnyFileExceedingMaxSize = (files: File[], maxFileSizeBytes: number) =>
  files.some((file) => file.size > maxFileSizeBytes)

export const createUploadedImage = (file: File): AiUploadedImage => ({
  id: uuid(),
  name: file.name,
  file,
  previewUrl: URL.createObjectURL(file),
})

export const createUploadedDocument = (file: File): AiUploadedDocument => ({
  id: uuid(),
  name: file.name,
  file,
  previewUrl: file.type.startsWith('image/') ? URL.createObjectURL(file) : undefined,
  uploadedAt: new Date(),
})

/** First file in the input that is an image or PDF (floor plan slot accepts both). */
export const pickFloorPlanFileFromList = (files: FileList) =>
  Array.from(files).find((selectedFile) => {
    return selectedFile.type.startsWith('image/') || selectedFile.type === 'application/pdf'
  })

/** First PDF in the input (energy certificate slot only accepts PDF). */
export const pickEnergyCertificateFileFromList = (files: FileList) =>
  Array.from(files).find((selectedFile) => selectedFile.type === 'application/pdf')
